<div class="autocomplete"
	 cpClickOut [closeOnScroll]="false" (clickOut)="close()">
	<div class="autocomplete-input" #anchor>
		<cp-search-box-widget #searchBox
		  [enableClearButton]="enableSearchBoxClearButton"
		  [placeholderTranslationKey]="placeholderTranslationKey"
		  [customButton]="customButton"
		  (customButtonClicked)="customButtonClicked.emit($event);"
		  (onClear)="onClearSearchBoxHandler()"
		  [focusOnInit]="focusOnInit"
		  [searchString]="searchString"
		  (focus)="focusChange.emit();"
		  (blur)="onBlur();"
		  (click)="onSearchBoxClick();"
		  class="no-bgc"
		  [placeHolders]="placeholder"
		  [disabled]="text.length < minChars"
		  [readOnly]="readOnly"
		  [debounce]="100"
		  [defaultSearchString]="defaultSearchString">
		</cp-search-box-widget>
	</div>

	<cp-tooltip *ngIf="isOpen"
				[anchor]="anchor"
				[label]="headerTitle"
				[labelParams]="headerTitleParams"
				[contentPadding]="0"
				[direction]="'bottom'"
				[forceOpen]="true"
				[alignCenter]="true"
				[tooltipPadding]="false">

		<ng-container *ngTemplateOutlet="headerTemplate; context: {allData: viewData, searchString: text};">
		</ng-container>

		<div *ngIf="!haveData()" class="autocomplete-nodata">
			<ng-template [ngTemplateOutlet]="noDataTemplate">
			</ng-template>
		</div>

		<div *ngIf="haveData()">
			<ng-template [ngTemplateOutlet]="contentTemplate">
			</ng-template>
		</div>

		<ul *ngIf="haveData() && itemTemplate" class="autocomplete-list">
			<li *ngFor="let item of viewData; trackBy: trackByIndex; let i = index;"
				class="autocomplete-item" [ngClass]="{'focused': navIndex === i}">
				<ng-template [ngTemplateOutlet]="itemTemplate"
							 [ngTemplateOutletContext]="{$implicit: item, index: i}">
				</ng-template>
			</li>
		</ul>

	</cp-tooltip>
</div>
